export enum AssessmentType {
  NIST = 'NIST',
  PCI = 'PCI',
  HIPPA = 'HIPPA'
}
export enum AssessmentStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}


export class Assessment {
  public id?: number;
  public name?: string;
  public type?: AssessmentType;
  public description?: string;
  public json?: {};
  public createdAt?: Date;
  public updatedAt?: Date;

  constructor(obj: Assessment = {} as Assessment) {
    this.id = obj.id;
    this.name = obj.name;
    this.type = obj.type;
    this.description = obj.description;
    this.json = obj.json;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}

export class AccountAssessment {
  public id?: number;
  public assessmentId?: number;
  public accountId?: number;
  public accountName?: string;
  public assessmentName?: string;
  public assessmentType?: string;
  public surveyResultsJson?: any;
  public scoredResultsJson?: any;
  public createdAt?: Date;
  public updatedAt?: Date;
  public currentPage?: number;
  public status?: AssessmentStatus;
  public percentComplete?: number;
  public percentCompleteStr?: string;
  public score?: number;
  public isLatest?: boolean;
  public prevId?: number;
  public nextId?: number;
  public startDate?: Date;
  public completeDate?: Date;
  public isActive? : boolean;
  public isAssessmentAllowed? : boolean;


  constructor(obj: AccountAssessment = {} as AccountAssessment) {
    this.id = obj.id;
    this.assessmentId = obj.assessmentId;
    this.accountId = obj.accountId;
    this.accountName = obj.accountName;
    this.assessmentName = obj.assessmentName;
    this.assessmentType = obj.assessmentType;
    this.surveyResultsJson = obj.surveyResultsJson;
    this.scoredResultsJson = obj.scoredResultsJson;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
    this.currentPage = obj.currentPage;
    this.status = obj.status;
    this.percentComplete = obj.percentComplete;
    this.isLatest = obj.isLatest;
    this.prevId = obj.prevId;
    this.nextId = obj.nextId;
    this.startDate = obj.startDate;
    this.completeDate = obj.completeDate;
    this.isActive = obj.isActive;
    this.isAssessmentAllowed = obj.isAssessmentAllowed;
    this.score = obj.score;
    this.percentCompleteStr = `${Math.floor(this.percentComplete * 100)}%`;
  }
}
